<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  // JR アイテム情報を持つVue Component 群
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  const itemsJ01 = Jewel01.data().items
  const itemsJ02 = Jewel02.data().items
  const itemsJ03 = Jewel03.data().items
  const itemsJ04 = Jewel04.data().items
  const itemsJ05 = Jewel05.data().items
  const itemsJ06 = Jewel06.data().items

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */

  /**
   * ジュエルレアのアイテム情報を得る
   * @param {ItemInfo[]} items
   * @param {string} id
   * @return {ItemInfo}
   * @see {externalItem}
   */
  function externalJR (items, id) {
    const collection = id.split('-')[0]  // "JR4-16" → "JR4"
    return externalItem(items, id, { collection })
  }

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-04-01',
        major: [],
        items: [

          // [NOTE] JR0
          // ================================================================================

          item({
            collection  : 'JR0',
            id          : 'JR0-01',
            rare        : 'JR',
            name        : 'ときめきのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-01',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-02',
            rare        : 'JR',
            name        : 'ときめきのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-02',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-03',
            rare        : 'JR',
            name        : 'ときめきのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-03',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-04',
            rare        : 'JR',
            name        : 'やさしさのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-04',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-05',
            rare        : 'JR',
            name        : 'やさしさのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-05',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-06',
            rare        : 'JR',
            name        : 'やさしさのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-06',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-07',
            rare        : 'JR',
            name        : 'ちしきのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-07',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-08',
            rare        : 'JR',
            name        : 'ちしきのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-08',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-09',
            rare        : 'JR',
            name        : 'ちしきのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-09',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-10',
            rare        : 'JR',
            name        : 'じゅんしんのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-10',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-11',
            rare        : 'JR',
            name        : 'じゅんしんのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-11',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-12',
            rare        : 'JR',
            name        : 'じゅんしんのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-12',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-13',
            rare        : 'JR',
            name        : 'しあわせのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-13',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-14',
            rare        : 'JR',
            name        : 'しあわせのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-14',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-15',
            rare        : 'JR',
            name        : 'しあわせのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-15',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-16',
            rare        : 'JR',
            name        : 'じょうねつのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-16',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-17',
            rare        : 'JR',
            name        : 'じょうねつのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-17',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-18',
            rare        : 'JR',
            name        : 'じょうねつのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-18',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-19',
            rare        : 'JR',
            name        : 'きぼうのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-19',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-20',
            rare        : 'JR',
            name        : 'きぼうのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-20',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-21',
            rare        : 'JR',
            name        : 'きぼうのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-21',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-22',
            rare        : 'JR',
            name        : 'せいぎのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-22',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-23',
            rare        : 'JR',
            name        : 'せいぎのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-23',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-24',
            rare        : 'JR',
            name        : 'せいぎのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-24',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-25',
            rare        : 'JR',
            name        : 'ゆうじょうのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-25',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-26',
            rare        : 'JR',
            name        : 'ゆうじょうのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-26',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-27',
            rare        : 'JR',
            name        : 'ゆうじょうのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-27',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JR0',
            id          : 'JR0-28',
            rare        : 'JR',
            name        : 'ゆうきのピュアジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-28',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 1500,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-29',
            rare        : 'JR',
            name        : 'ゆうきのピュアジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-29',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JR0',
            id          : 'JR0-30',
            rare        : 'JR',
            name        : 'ゆうきのピュアジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR0-30',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0, kira: 0 },
            numReleased : { usual: 0, kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JR1
          // ================================================================================

          externalJR(itemsJ01, 'JR1-01'),
          externalJR(itemsJ01, 'JR1-02'),
          externalJR(itemsJ01, 'JR1-03'),
          externalJR(itemsJ01, 'JR1-04'),
          externalJR(itemsJ01, 'JR1-05'),
          externalJR(itemsJ01, 'JR1-06'),
          externalJR(itemsJ01, 'JR1-07'),
          externalJR(itemsJ01, 'JR1-08'),
          externalJR(itemsJ01, 'JR1-09'),
          externalJR(itemsJ01, 'JR1-10'),
          externalJR(itemsJ01, 'JR1-11'),
          externalJR(itemsJ01, 'JR1-12'),
          externalJR(itemsJ01, 'JR1-13'),
          externalJR(itemsJ01, 'JR1-14'),
          externalJR(itemsJ01, 'JR1-15'),
          externalJR(itemsJ01, 'JR1-16'),
          externalJR(itemsJ01, 'JR1-17'),
          externalJR(itemsJ01, 'JR1-18'),
          externalJR(itemsJ01, 'JR1-19'),
          externalJR(itemsJ01, 'JR1-20'),
          externalJR(itemsJ01, 'JR1-21'),
          externalJR(itemsJ01, 'JR1-22'),
          externalJR(itemsJ01, 'JR1-23'),
          externalJR(itemsJ01, 'JR1-24'),
          externalJR(itemsJ01, 'JR1-25'),
          externalJR(itemsJ01, 'JR1-26'),
          externalJR(itemsJ01, 'JR1-27'),
          externalJR(itemsJ01, 'JR1-28'),
          externalJR(itemsJ01, 'JR1-29'),
          externalJR(itemsJ01, 'JR1-30'),


          // [NO2E] JR2
          // ================================================================================

          externalJR(itemsJ02, 'JR2-04'),
          externalJR(itemsJ02, 'JR2-05'),
          externalJR(itemsJ02, 'JR2-06'),
          externalJR(itemsJ02, 'JR2-07'),
          externalJR(itemsJ02, 'JR2-08'),
          externalJR(itemsJ02, 'JR2-09'),
          externalJR(itemsJ02, 'JR2-01'),
          externalJR(itemsJ02, 'JR2-02'),
          externalJR(itemsJ02, 'JR2-03'),
          externalJR(itemsJ02, 'JR2-10'),
          externalJR(itemsJ02, 'JR2-11'),
          externalJR(itemsJ02, 'JR2-12'),
          externalJR(itemsJ02, 'JR2-13'),
          externalJR(itemsJ02, 'JR2-14'),
          externalJR(itemsJ02, 'JR2-15'),
          externalJR(itemsJ02, 'JR2-16'),
          externalJR(itemsJ02, 'JR2-17'),
          externalJR(itemsJ02, 'JR2-18'),
          externalJR(itemsJ02, 'JR2-19'),
          externalJR(itemsJ02, 'JR2-20'),
          externalJR(itemsJ02, 'JR2-21'),
          externalJR(itemsJ02, 'JR2-22'),
          externalJR(itemsJ02, 'JR2-23'),
          externalJR(itemsJ02, 'JR2-24'),
          externalJR(itemsJ02, 'JR2-25'),
          externalJR(itemsJ02, 'JR2-26'),
          externalJR(itemsJ02, 'JR2-27'),
          externalJR(itemsJ02, 'JR2-28'),
          externalJR(itemsJ02, 'JR2-29'),
          externalJR(itemsJ02, 'JR2-30'),


          // [NO2E] JR3
          // ================================================================================

          externalJR(itemsJ02, 'JR3-04'),
          externalJR(itemsJ02, 'JR3-05'),
          externalJR(itemsJ02, 'JR3-06'),
          externalJR(itemsJ02, 'JR3-07'),
          externalJR(itemsJ02, 'JR3-08'),
          externalJR(itemsJ02, 'JR3-09'),
          externalJR(itemsJ02, 'JR3-10'),
          externalJR(itemsJ02, 'JR3-11'),
          externalJR(itemsJ02, 'JR3-12'),
          externalJR(itemsJ02, 'JR3-13'),
          externalJR(itemsJ02, 'JR3-14'),
          externalJR(itemsJ02, 'JR3-15'),
          externalJR(itemsJ02, 'JR3-16'),
          externalJR(itemsJ02, 'JR3-17'),
          externalJR(itemsJ02, 'JR3-18'),
          externalJR(itemsJ02, 'JR3-19'),
          externalJR(itemsJ02, 'JR3-20'),
          externalJR(itemsJ02, 'JR3-21'),
          externalJR(itemsJ02, 'JR3-22'),
          externalJR(itemsJ02, 'JR3-23'),
          externalJR(itemsJ02, 'JR3-24'),
          externalJR(itemsJ02, 'JR3-01'),
          externalJR(itemsJ02, 'JR3-02'),
          externalJR(itemsJ02, 'JR3-03'),
          externalJR(itemsJ02, 'JR3-25'),
          externalJR(itemsJ02, 'JR3-26'),
          externalJR(itemsJ02, 'JR3-27'),
          externalJR(itemsJ02, 'JR3-28'),
          externalJR(itemsJ02, 'JR3-29'),
          externalJR(itemsJ02, 'JR3-30'),


          // [NO2E] JR4
          // ================================================================================

          externalJR(itemsJ03, 'JR4-04'),
          externalJR(itemsJ03, 'JR4-05'),
          externalJR(itemsJ03, 'JR4-06'),
          externalJR(itemsJ03, 'JR4-07'),
          externalJR(itemsJ03, 'JR4-08'),
          externalJR(itemsJ03, 'JR4-09'),
          externalJR(itemsJ03, 'JR4-10'),
          externalJR(itemsJ03, 'JR4-11'),
          externalJR(itemsJ03, 'JR4-12'),
          externalJR(itemsJ03, 'JR4-01'),
          externalJR(itemsJ03, 'JR4-02'),
          externalJR(itemsJ03, 'JR4-03'),
          externalJR(itemsJ03, 'JR4-13'),
          externalJR(itemsJ03, 'JR4-14'),
          externalJR(itemsJ03, 'JR4-15'),
          externalJR(itemsJ03, 'JR4-19'),
          externalJR(itemsJ03, 'JR4-20'),
          externalJR(itemsJ03, 'JR4-21'),
          externalJR(itemsJ03, 'JR4-22'),
          externalJR(itemsJ03, 'JR4-23'),
          externalJR(itemsJ03, 'JR4-24'),
          externalJR(itemsJ03, 'JR4-25'),
          externalJR(itemsJ03, 'JR4-26'),
          externalJR(itemsJ03, 'JR4-27'),
          externalJR(itemsJ03, 'JR4-28'),
          externalJR(itemsJ03, 'JR4-29'),
          externalJR(itemsJ03, 'JR4-30'),
          externalJR(itemsJ03, 'JR4-31'),
          externalJR(itemsJ03, 'JR4-32'),
          externalJR(itemsJ03, 'JR4-33'),


          // [NO2E] JR5
          // ================================================================================

          externalJR(itemsJ03, 'JR5-04'),
          externalJR(itemsJ03, 'JR5-05'),
          externalJR(itemsJ03, 'JR5-06'),
          externalJR(itemsJ03, 'JR5-07'),
          externalJR(itemsJ03, 'JR5-08'),
          externalJR(itemsJ03, 'JR5-09'),
          externalJR(itemsJ03, 'JR5-10'),
          externalJR(itemsJ03, 'JR5-11'),
          externalJR(itemsJ03, 'JR5-12'),
          externalJR(itemsJ03, 'JR5-13'),
          externalJR(itemsJ03, 'JR5-14'),
          externalJR(itemsJ03, 'JR5-15'),
          externalJR(itemsJ03, 'JR5-01'),
          externalJR(itemsJ03, 'JR5-02'),
          externalJR(itemsJ03, 'JR5-03'),
          externalJR(itemsJ03, 'JR5-16'),
          externalJR(itemsJ03, 'JR5-17'),
          externalJR(itemsJ03, 'JR5-18'),
          externalJR(itemsJ03, 'JR5-19'),
          externalJR(itemsJ03, 'JR5-20'),
          externalJR(itemsJ03, 'JR5-21'),
          externalJR(itemsJ03, 'JR5-22'),
          externalJR(itemsJ03, 'JR5-23'),
          externalJR(itemsJ03, 'JR5-24'),
          externalJR(itemsJ03, 'JR5-25'),
          externalJR(itemsJ03, 'JR5-26'),
          externalJR(itemsJ03, 'JR5-27'),
          externalJR(itemsJ03, 'JR5-28'),
          externalJR(itemsJ03, 'JR5-29'),
          externalJR(itemsJ03, 'JR5-30'),


          // [NOTE] JR6
          // ================================================================================

          externalJR(itemsJ04, 'JR6-04'),
          externalJR(itemsJ04, 'JR6-05'),
          externalJR(itemsJ04, 'JR6-06'),
          externalJR(itemsJ04, 'JR6-07'),
          externalJR(itemsJ04, 'JR6-08'),
          externalJR(itemsJ04, 'JR6-09'),
          externalJR(itemsJ04, 'JR6-10'),
          externalJR(itemsJ04, 'JR6-11'),
          externalJR(itemsJ04, 'JR6-12'),
          externalJR(itemsJ04, 'JR6-13'),
          externalJR(itemsJ04, 'JR6-14'),
          externalJR(itemsJ04, 'JR6-15'),
          externalJR(itemsJ04, 'JR6-16'),
          externalJR(itemsJ04, 'JR6-17'),
          externalJR(itemsJ04, 'JR6-18'),
          externalJR(itemsJ04, 'JR6-19'),
          externalJR(itemsJ04, 'JR6-20'),
          externalJR(itemsJ04, 'JR6-21'),
          externalJR(itemsJ04, 'JR6-01'),
          externalJR(itemsJ04, 'JR6-02'),
          externalJR(itemsJ04, 'JR6-03'),
          externalJR(itemsJ04, 'JR6-22'),
          externalJR(itemsJ04, 'JR6-23'),
          externalJR(itemsJ04, 'JR6-24'),
          externalJR(itemsJ04, 'JR6-25'),
          externalJR(itemsJ04, 'JR6-26'),
          externalJR(itemsJ04, 'JR6-27'),
          externalJR(itemsJ04, 'JR6-28'),
          externalJR(itemsJ04, 'JR6-29'),
          externalJR(itemsJ04, 'JR6-30'),


          // [NOTE] JR7
          // ================================================================================

          externalJR(itemsJ04, 'JR7-04'),
          externalJR(itemsJ04, 'JR7-05'),
          externalJR(itemsJ04, 'JR7-06'),
          externalJR(itemsJ04, 'JR7-07'),
          externalJR(itemsJ04, 'JR7-08'),
          externalJR(itemsJ04, 'JR7-09'),
          externalJR(itemsJ04, 'JR7-10'),
          externalJR(itemsJ04, 'JR7-11'),
          externalJR(itemsJ04, 'JR7-12'),
          externalJR(itemsJ04, 'JR7-13'),
          externalJR(itemsJ04, 'JR7-14'),
          externalJR(itemsJ04, 'JR7-15'),
          externalJR(itemsJ04, 'JR7-16'),
          externalJR(itemsJ04, 'JR7-17'),
          externalJR(itemsJ04, 'JR7-18'),
          externalJR(itemsJ04, 'JR7-19'),
          externalJR(itemsJ04, 'JR7-20'),
          externalJR(itemsJ04, 'JR7-21'),
          externalJR(itemsJ04, 'JR7-22'),
          externalJR(itemsJ04, 'JR7-23'),
          externalJR(itemsJ04, 'JR7-24'),
          externalJR(itemsJ04, 'JR7-25'),
          externalJR(itemsJ04, 'JR7-26'),
          externalJR(itemsJ04, 'JR7-27'),
          externalJR(itemsJ04, 'JR7-01'),
          externalJR(itemsJ04, 'JR7-02'),
          externalJR(itemsJ04, 'JR7-03'),
          externalJR(itemsJ04, 'JR7-28'),
          externalJR(itemsJ04, 'JR7-29'),
          externalJR(itemsJ04, 'JR7-30'),


          // [NOTE] JR8
          // ================================================================================

          externalJR(itemsJ05, 'JR8-04'),
          externalJR(itemsJ05, 'JR8-05'),
          externalJR(itemsJ05, 'JR8-06'),
          externalJR(itemsJ05, 'JR8-07'),
          externalJR(itemsJ05, 'JR8-08'),
          externalJR(itemsJ05, 'JR8-09'),
          externalJR(itemsJ05, 'JR8-10'),
          externalJR(itemsJ05, 'JR8-11'),
          externalJR(itemsJ05, 'JR8-12'),
          externalJR(itemsJ05, 'JR8-13'),
          externalJR(itemsJ05, 'JR8-14'),
          externalJR(itemsJ05, 'JR8-15'),
          externalJR(itemsJ05, 'JR8-16'),
          externalJR(itemsJ05, 'JR8-17'),
          externalJR(itemsJ05, 'JR8-18'),
          externalJR(itemsJ05, 'JR8-01'),
          externalJR(itemsJ05, 'JR8-02'),
          externalJR(itemsJ05, 'JR8-03'),
          externalJR(itemsJ05, 'JR8-19'),
          externalJR(itemsJ05, 'JR8-20'),
          externalJR(itemsJ05, 'JR8-21'),
          externalJR(itemsJ05, 'JR8-22'),
          externalJR(itemsJ05, 'JR8-23'),
          externalJR(itemsJ05, 'JR8-24'),
          externalJR(itemsJ05, 'JR8-25'),
          externalJR(itemsJ05, 'JR8-26'),
          externalJR(itemsJ05, 'JR8-27'),
          externalJR(itemsJ05, 'JR8-28'),
          externalJR(itemsJ05, 'JR8-29'),
          externalJR(itemsJ05, 'JR8-30'),


          // [NOTE] JR9
          // ================================================================================

          externalJR(itemsJ05, 'JR9-04'),
          externalJR(itemsJ05, 'JR9-05'),
          externalJR(itemsJ05, 'JR9-06'),
          externalJR(itemsJ05, 'JR9-07'),
          externalJR(itemsJ05, 'JR9-08'),
          externalJR(itemsJ05, 'JR9-09'),
          externalJR(itemsJ05, 'JR9-10'),
          externalJR(itemsJ05, 'JR9-11'),
          externalJR(itemsJ05, 'JR9-12'),
          externalJR(itemsJ05, 'JR9-13'),
          externalJR(itemsJ05, 'JR9-14'),
          externalJR(itemsJ05, 'JR9-15'),
          externalJR(itemsJ05, 'JR9-16'),
          externalJR(itemsJ05, 'JR9-17'),
          externalJR(itemsJ05, 'JR9-18'),
          externalJR(itemsJ05, 'JR9-19'),
          externalJR(itemsJ05, 'JR9-20'),
          externalJR(itemsJ05, 'JR9-21'),
          externalJR(itemsJ05, 'JR9-22'),
          externalJR(itemsJ05, 'JR9-23'),
          externalJR(itemsJ05, 'JR9-24'),
          externalJR(itemsJ05, 'JR9-25'),
          externalJR(itemsJ05, 'JR9-26'),
          externalJR(itemsJ05, 'JR9-27'),
          externalJR(itemsJ05, 'JR9-28'),
          externalJR(itemsJ05, 'JR9-29'),
          externalJR(itemsJ05, 'JR9-30'),
          externalJR(itemsJ05, 'JR9-01'),
          externalJR(itemsJ05, 'JR9-02'),
          externalJR(itemsJ05, 'JR9-03'),


          // [NOTE] JR10
          // ================================================================================

          externalJR(itemsJ06, 'JR10-04'),
          externalJR(itemsJ06, 'JR10-05'),
          externalJR(itemsJ06, 'JR10-06'),
          externalJR(itemsJ06, 'JR10-01'),
          externalJR(itemsJ06, 'JR10-02'),
          externalJR(itemsJ06, 'JR10-03'),
          externalJR(itemsJ06, 'JR10-07'),
          externalJR(itemsJ06, 'JR10-08'),
          externalJR(itemsJ06, 'JR10-09'),
          externalJR(itemsJ06, 'JR10-10'),
          externalJR(itemsJ06, 'JR10-11'),
          externalJR(itemsJ06, 'JR10-12'),
          externalJR(itemsJ06, 'JR10-13'),
          externalJR(itemsJ06, 'JR10-14'),
          externalJR(itemsJ06, 'JR10-15'),
          externalJR(itemsJ06, 'JR10-16'),
          externalJR(itemsJ06, 'JR10-17'),
          externalJR(itemsJ06, 'JR10-18'),
          externalJR(itemsJ06, 'JR10-19'),
          externalJR(itemsJ06, 'JR10-20'),
          externalJR(itemsJ06, 'JR10-21'),
          externalJR(itemsJ06, 'JR10-22'),
          externalJR(itemsJ06, 'JR10-23'),
          externalJR(itemsJ06, 'JR10-24'),
          externalJR(itemsJ06, 'JR10-25'),
          externalJR(itemsJ06, 'JR10-26'),
          externalJR(itemsJ06, 'JR10-27'),
          externalJR(itemsJ06, 'JR10-28'),
          externalJR(itemsJ06, 'JR10-29'),
          externalJR(itemsJ06, 'JR10-30'),


          // [NOTE] JR11
          // ================================================================================

          externalJR(itemsJ06, 'JR11-01'),
          externalJR(itemsJ06, 'JR11-02'),
          externalJR(itemsJ06, 'JR11-03'),
        ],
      }
    },

    computed: {
      itemsJR0  () { return _.where(this.items, { collection: 'JR0'  }) },
      itemsJR1  () { return _.where(this.items, { collection: 'JR1'  }) },
      itemsJR2  () { return _.where(this.items, { collection: 'JR2'  }) },
      itemsJR3  () { return _.where(this.items, { collection: 'JR3'  }) },
      itemsJR4  () { return _.where(this.items, { collection: 'JR4'  }) },
      itemsJR5  () { return _.where(this.items, { collection: 'JR5'  }) },
      itemsJR6  () { return _.where(this.items, { collection: 'JR6'  }) },
      itemsJR7  () { return _.where(this.items, { collection: 'JR7'  }) },
      itemsJR8  () { return _.where(this.items, { collection: 'JR8'  }) },
      itemsJR9  () { return _.where(this.items, { collection: 'JR9'  }) },
      itemsJR10 () { return _.where(this.items, { collection: 'JR10' }) },
      itemsJR11 () { return _.where(this.items, { collection: 'JR11' }) },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,3,4,5,6,7,8,9,10,11,12]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1 ><ItemList title="JR0 ピュア"        color="#b6d6d6" :items="itemsJR0"  /></template>
    <template #col2 ><ItemList title="JR1 ときめき"      color="#ffa1bc" :items="itemsJR1"  /></template>
    <template #col3 ><ItemList title="JR2 やさしさ"      color="#00c7da" :items="itemsJR2"  /></template>
    <template #col4 ><ItemList title="JR3 ちしき"        color="#c598ff" :items="itemsJR3"  /></template>
    <template #col5 ><ItemList title="JR4 じゅんしん"    color="#b3aba2" :items="itemsJR4"  /></template>
    <template #col6 ><ItemList title="JR5 しあわせ"      color="#feab0d" :items="itemsJR5"  /></template>
    <template #col7 ><ItemList title="JR6 じょうねつ"    color="#44cd1f" :items="itemsJR6"  /></template>
    <template #col8 ><ItemList title="JR7 きぼう"        color="#b6d6d6" :items="itemsJR7"  /></template>
    <template #col9 ><ItemList title="JR8 せいぎ"        color="#ff5d91" :items="itemsJR8"  /></template>
    <template #col10><ItemList title="JR9 ゆうじょう"    color="#ff9300" :items="itemsJR9"  /></template>
    <template #col11><ItemList title="JR10 ゆうき"       color="#edd50f" :items="itemsJR10" /></template>
    <template #col12><ItemList title="JR11 ダイヤモンド" color="#ffa1bc" :items="itemsJR11" />
      <Status :date="date" :items="items" />
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .Page ::v-deep .Status__body.-result {
    display: none;
  }

  // (position: absolute になっている) PC 画面のみ
  .Page ::v-deep .Status {
    bottom: 0;
  }
</style>
